<div class="conatinerSucces">
<div class="container u-mt60">
  <div class="row">
    <div class="col-12">
      <div class="breadcrumbs">
        <ul>
          <li>
            <a routerLink="/dashboard">
              Inicio
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-8">
      <h1 class="u-mb60 txt txt--title">
        Delegación aprobaciones
      </h1>
    </div>
  </div>
</div>
<div class="bg--lightgrey u-pt50 u-pb70">
  <div class="container">
    <div class="row">
      <div class="col-md-8 offset-md-2">
        <div class="u-center">
          <div class="icon icon--success u-mb30"></div>
          <h2 class="u-mb30 txt txt--subtitle">
            Las aprobaciones han sido delegadas correctamente
          </h2>
          <div class="box box--white u-mb40">
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <p class="txt txt-paragraph u-mb0">
                  Una copia de la delegación fue enviada al
                  correo electrónico {{email}}
                </p>
              </div>
            </div>
          </div>
          <div class="u-mb50">
            <button type="button" class="btn btn--primary" routerLink="/delegate">Ver aprobaciones
              pendientes</button>
            <!-- <a type="button" class="btn btn--primary" href="/delegate/by-time">Ver aprobaciones pendientes</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>
